import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,  HttpRequest, HttpEvent, HttpParams, HttpResponse, HttpErrorResponse  } from '@angular/common/http';
import { Meta } from '@angular/platform-browser';
import { catchError, map, throwError } from 'rxjs';
import { HelperService } from '../_helpers/helper.service';
import { AppSettings } from '../_helpers/app.settings';
import { AppMessages } from '../_helpers/app.messages';
import { TokenStorageService } from '../_helpers/token-storage.service';
import { Route, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NotificationService } from '../_helpers/notification.service';
@Injectable({
  providedIn: 'root'
})
export class HttpService {

  savedRoute: string = '';

  constructor(private http: HttpClient,
    private helper: HelperService,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private modalService: BsModalService,
    private notificationService: NotificationService
    ) { }
  sendRequest(param: any) {
    let obj = {
      method: param.method,
      reqBody: param.reqBody,
      queryParam: param.queryParam ? param.queryParam : null,
      contentType: param.contentType,
      url: param.url,
      skipToken: param.skipToken
    };
    let options: any = this.prepareReqObj(obj);
    if(param.downloadFile) {
      options = this.getOptionsForDownloadFile();
    }

    this.http.request(param.method, `${param.url}${this.getQueryString(param)}`, options)
    .pipe(
      map(this.parseData.bind(this)),
      catchError(this.handleError.bind(this))
    ).subscribe(
      (data: any) => {
        let response: any;
        if(param.downloadFile) {
          param.success(data);
          return;
        }
        if((data && data.body) || (data.status && this.helper.contains(AppSettings.SUCCESS_CODES, data.status))) {
          if(data.body) {
            response = data.body;
          } else {
            response = {code: data.status, success: true};
          }
          if(response && typeof response == "object" && ("errorMessage" in response || ("error" in response))) {
            // this.processResponse(response);
            if(param.error) {
              if(!this.isTokenExpired(data)) {
                param.error(response);
              }
            }
          } else {
            if(param.success) {
              param.success(response);
            }
          }
        } else {
          if(param.error) {
            if(!this.isTokenExpired(data)) {
              param.error(response);
            }
          }
        }
      }, error => {
        //:todo handle error if require
        if(param.error) {
          if(!this.isTokenExpired(error)) {
            param.error(error);
          }
        }
      }
    )
  }
  isTokenExpired(data: any): boolean {
    //401 is for invalid credentials and also for token expire
    if(data.errorCode == AppSettings.TOKEN_EXPIRE_CODE) {
      this.savedRoute = this.router.url;
      this.helper.showLoader(false);
      this.modalService.hide();
      // this.notificationService.showError("Session expired. Please login again.");
      this.tokenStorage.signOut(data.errorMessage, true);
      // this.router.navigate([AppSettings.LOGIN_ROUTE]);
      return true;
    }
    return false;
  }
  getOptionsForDownloadFile() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', `Bearer ${this.tokenStorage.getToken()}`);
    return {
      headers: headers,
      responseType: 'blob' as 'text'
    };
  }
  prepareReqObj(param: any) {
    let headers = new HttpHeaders();
    if(!param.contentType) {
      param.contentType = "application/json";
    }
    headers = headers.append('Content-Type', param.contentType);
    if(!param.skipToken) {
      headers = headers.append('Authorization', `Bearer ${this.tokenStorage.getToken()}`);
    }
    //:todo add additional headers here if required

    let querySt = new HttpParams();
    if(param.queryParam !== null) {
      Object.keys(param.queryParam).map((obj) => {
        querySt = querySt.set(obj, param.queryParam[obj]);
      });
    }
    if(param.responseType) {
    headers = headers.append('Content-Type', param.contentType);

    }
    if(param.responseType) {
      
    }
    return {
      body: param.reqBody,
      headers: headers,
      observe: 'response',
      params: querySt
    };
  }
  getQueryString(param: any) {
    let querySt = '';
    if(param.queryString) {
      let queryList: any = [];
      Object.keys(param.queryString).forEach(query => {
        queryList.push(`${query}=${param.queryString[query]}`);
      });
      if(queryList.length) {
        querySt = queryList.join("&");
      }
    }
    return querySt;
  }
  parseData(response: HttpResponse<Response> | any) {
    let headers = new HttpHeaders();

    headers = response.headers;
    if(headers && headers.get("Content-Type") === "application/json;charset=UTF-8") {
      let body: any = response;
      if(response.status && this.helper.contains(AppSettings.SUCCESS_CODES, response.status)) {
        return body;
      }
      // body.errorMessage = body.message;
      //:todo if error is not working properly, check here
      return throwError(() => {
        return {
          errorCode: response.status,
          errorMessage: body.message
        };
      });
    } else {
      return response;
    }
  }
  handleError(error: HttpErrorResponse | any) {
      let errorMessage: string = AppMessages.SOMETHING_WRONG;
      let errorObj: any = {};

      if(error instanceof HttpErrorResponse) {
        try {
          if(error && error.status) {
            errorObj.errorCode = error.status;
          }
          //backend is giving error message in error.error
          if(error.error?.message) {
            errorObj.errorMessage = error.error.message;
          } else if(!errorObj.errorMessage && error.status == AppSettings.TOKEN_EXPIRE_CODE) {
            // if token is espired, backend is not giving error message, so we need to show this message from UI
            errorObj.errorMessage = "Session expired. Please login again.";
          } else {
            errorObj.errorMessage = error.message ||  errorMessage;
          }
        } catch(e) {
          console.log(e);
        }
      }
      return throwError(() => {
        return errorObj;
      });
  }
  clearSavedRoute() {
    this.savedRoute = '';
  }
}
